import { BareActionContext } from 'vuex-typex'
import { PostState } from '../state'
import { RootState } from '../..'
import postStore from '../post-store'

export default async function resetPostForm(context: BareActionContext<PostState, RootState>)
{
    postStore.commitResetPostForm({})

    return
}
